import rng from './rng';
import unsafeStringify from './unsafeStringify';

export const generateUuid = () => {
  if (window.crypto.randomUUID) return window.crypto.randomUUID();

  const rnds = rng();

  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  return unsafeStringify(rnds);
};
